export default __webpack_public_path__ + "static/media/judging-rubric.7354d9ff.pdf";